/** Monta a gaveta de ajuda só depois da primeira abertura (o markdown e o renderizador ficam fora do bundle inicial). */
import { lazy, Suspense, useEffect, useState } from "react";
import { useHelpTarget } from "./store";

const HelpDrawer = lazy(() => import("./HelpDrawer").then((m) => ({ default: m.HelpDrawer })));

export function HelpDrawerHost() {
  const target = useHelpTarget();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (target) setLoaded(true);
  }, [target]);
  if (!loaded) return null;
  return (
    <Suspense fallback={null}>
      <HelpDrawer />
    </Suspense>
  );
}
